module.exports = __webpack_public_path__ + "img/swingVariabilityText2.522c6c3a.png";